exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-dropzone>.dz-preview .dz-details{background-color:var(--v-primary-base)}.successUpload>.dz-preview .dz-details{background-color:var(--v-primary-base)!important}.errorUpload>.dz-preview .dz-details{background-color:var(--v-error-base)!important}", ""]);

// exports
